import React, {Component} from 'react';
import keycode from 'keycode';
import range from 'lodash/range';
import classNames from 'classnames';
import BrowserDetection from 'react-browser-detection';

import './App.css';
import P5Wrapper from './components/P5Wrapper';
import CanvasFrame from './components/CanvasFrame';
import DotMouseWrapper from './components/DotMouseWrapper';

import automaticPaint from './sketches/automatic-paint';
import automaticPaintWithPaint from './sketches/automatic-paint-with-paint';
import backgroundsketch from './sketches/full-background-sketch';
import centerWaterColor from './sketches/center-water-color';
import movingWaterColor from './sketches/moving-bits-watercolor.js';
import movingLines from './sketches/moving-lines';
import frequencyInColor from './sketches/frequency-in-color';
import mapOfBus from './sketches/map';
import frequencyInSpace from './sketches/frequency-in-space';
import particles from './sketches/particles';
import sketch from './sketches/sketch';
import trees from './sketches/trees';
import watercolor from './sketches/watercolor';
import treeOfSound from './sketches/tree-of-sound';

const defaultNoteColors = [
  '#FF0001',
  '#FF4401',
  '#D66F01',
  '#FFC503',
  '#E0EA03',
  '#76D102',
  '#01FFAB',
  '#00FFE7',
  '#00B2FF',
  '#3409FF',
  '#9E07FF',
  '#FF03FD',
];

const minBrowserVersions = {
  chrome: '22',
};

const sketches = {
  Pintura: sketch,
  'Pintura automática com fundo': automaticPaintWithPaint,
  'Linhas em Movimento': movingLines,
  'Frequência no espaço': frequencyInSpace,
  'Partículas redondas': treeOfSound,
  'Partículas quadradas': frequencyInColor,
  Fundo: backgroundsketch,
  Árvore: trees,
  'Aquarela Centralizada': centerWaterColor,
  'Aquarela em Movimento': movingWaterColor,
  'Mapa de ônibus': mapOfBus,
  // 'Automatic Paint': automaticPaint,
  // 'Aquarela Generativa, Prova de Conceito': watercolor,
  // Particles: particles,
};

const defaultSketch = sketch;
const defaultSketchName = 'Paint';

// const defaultSketch = trees;
// const defaultSketchName = 'Trees';

// const defaultSketch = centerWaterColor;
// const defaultSketchName = 'Center Water Color';

// const defaultSketch = movingLines;
// const defaultSketchName = 'Moving Lines';

// const defaultSketch = automaticPaintWithPaint;
// const defaultSketchName = 'Pintura automática com fundo';

// const defaultSketch = automaticPaintWithPaint;
// const defaultSketchName = 'Pintura automática com fundo';

// const defaultSketch = frequencyInColor;
// const defaultSketchName = 'Partículas quadradas';

// const defaultSketch = treeOfSound;
// const defaultSketchName = 'Tree of Sound';

// const defaultSketch = watercolor;
// const defaultSketchName = 'Water Color';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // collapsed: true,
      // modalVisible: false,

      modalVisible: true,

      p5State: {},
      sketch: defaultSketch,
      currentSketchName: defaultSketchName,
      brushName: 'Water Color',
      colors: defaultNoteColors,
    };
  }

  onChangeP5 = p5State => {
    this.setState({
      p5State,
    });

    if (!this.state.slider1Value && p5State.slider1) {
      this.setState({
        slider1Value: p5State.slider1.value,
      });
    }
  };

  onChangeSketch = e => {
    this.setState({
      sketch: sketches[e.target.value],
      currentSketchName: e.target.value,
    });
  };

  onChangeCollapse = e => {
    if (e) e.stopPropagation();
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  onChangeSlider1 = e => {
    this.setState({
      slider1Value: e.target.value,
    });
  };

  onChangeBrush = e => {
    this.setState({
      brushName: e.target.value,
    });
  };

  onChangeBackground = e => {
    this.setState({
      background: `rgba(${e.rgb.r}, ${e.rgb.g}, ${e.rgb.b}, ${e.rgb.a})`,
    });
  };

  onKeyDown = e => {
    if (keycode('c') === e.keyCode) {
      this.setState({
        brushName: 'Circle',
      });
    }

    if (keycode('s') === e.keyCode) {
      this.setState({
        brushName: 'Square',
      });
    }

    if (keycode('w') === e.keyCode) {
      this.setState({
        brushName: 'Water Color',
      });
    }

    if (keycode('a') === e.keyCode) {
      this.onToggleHoldDraw();
    }

    if (keycode(e.keyCode) === 'space') {
      this.onChangeCollapse();
    }

    range(0, 10).forEach(n => {
      if (keycode(`${n}`) === e.keyCode) {
        console.log('here');
        this.setState({
          slider1Value: 4500 / 9 * n,
        });
      }
    });
  };

  onClickDownloadImage = e => {
    // e.preventDefault();
    const link = document.querySelector('#download');
    const url = document.querySelector('.P5Wrapper canvas').toDataURL();
    link.href = url;
    link.download = 'spaint-' + new Date().toISOString() + '.png';
  };

  onToggleHoldDraw = () => {
    this.setState({
      holdDraw: !this.state.holdDraw,
    });
  };

  onChangeColors = colors => {
    console.log(JSON.stringify(colors));
    this.setState({
      colors,
    });
  };

  render() {
    return (
      <div className="App" tabIndex="0" onKeyDown={this.onKeyDown}>
        {this.state.modalVisible ? (
          <div className="AppModal">
            <div className="AppModal__Content">
              <h1>spaint</h1>
              <div className="text-left">
                <BrowserDetection>
                  {{
                    chrome: () => {
                      return null;
                    },
                    default: () => {
                      return (
                        <strong>
                          Infelizmente no momento somente o chrome é suportado
                        </strong>
                      );
                    },
                  }}
                </BrowserDetection>
                <p>
                  <strong>spaint</strong> é um programa de desenho que reage ao
                  som.
                </p>
                <p>Experimente assobiar e clicar e arrastar o mouse.</p>
                <p>
                  Cada frequência detectada é aproximada para uma nota musical e
                  cada nota faz o pincel ter uma nova cor.
                </p>
                <p>O tamanho do pincel é a amplitude do sinal.</p>
                <p>Apertar 'c', 's' ou 'w' muda o pincel usado.</p>
                <p>
                  O pincel padrão é uma aquarela generativa baseada no trabalho
                  de Tyler Hobbs.
                </p>
                <p>
                  Apertar 'a' faz com que o desenho seja feito idependente de se
                  o mouse é apertado.
                </p>
                <p>
                  As teclas numéricas mudam a relação entre o volume e o tamanho
                  do pincel.
                </p>
                <p>
                  Há várias outras visualizações de som disponíveis no canto
                  superior direito da tela.
                </p>
                <p>
                  Sempre, a barra de espaço esconde e mostra o visualizador do
                  topo.
                </p>
              </div>
              <button
                style={{
                  fontSize: 20,
                }}
                onClick={() =>
                  this.setState({
                    modalVisible: false,
                  })
                }
              >
                Começar
              </button>
            </div>
            <div className="AppModal__Overlay" />
          </div>
        ) : null}

        <CanvasFrame
          background={this.state.background || '#000'}
          collapsed={this.state.collapsed}
          onChangeCollapse={this.onChangeCollapse}
          onChangeBackground={this.onChangeBackground}
          currentSketchName={this.state.currentSketchName}
          onClickDownloadImage={this.onClickDownloadImage}
          onChangeBrush={this.onChangeBrush}
          onChangeSketch={this.onChangeSketch}
          sketches={sketches}
          p5State={this.state.p5State}
          onChangeSlider1={this.onChangeSlider1}
          slider1Value={this.state.slider1Value}
          holdDraw={this.state.holdDraw}
          onToggleHoldDraw={this.onToggleHoldDraw}
          colors={this.state.colors}
          onChangeColors={this.onChangeColors}
        >
          <DotMouseWrapper p5State={this.state.p5State}>
            <P5Wrapper
              className="P5Wrapper"
              onChange={this.onChangeP5}
              sketch={this.state.sketch}
              slider1Value={this.state.slider1Value}
              background={this.state.background}
              brushName={this.state.brushName}
              holdDraw={this.state.holdDraw}
              colors={this.state.colors}
            />
          </DotMouseWrapper>
        </CanvasFrame>

        {/*
        <div
          style={{
            position: 'absolute',
            bottom: 20,
            right: 20,
            color: 'rgba(255, 255, 255, 0.8)',
          }}
        >
          Cada nota tem uma cor - spaint.beijaflor.io
        </div>
*/}

        {/*
        <div
          className={classNames('ContextualMenu', {
            recording: this.state.recording,
          })}
        >
          <img src={require('./video.png')} />
        </div>
        */}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js